import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog.vue";
import SelectClient from "@/components/Widgets/Select/select-client";
import SelectFranchisee from "@/components/Widgets/Select/select-franchisee.vue";
import SelectUnit from "@/components/Widgets/Select/select-unit.vue";
import ChartAlert from "@/components/charts/ChartsDashboard/Alert.vue";
import ChartCall from "@/components/charts/ChartsDashboard/Call.vue";
import ChartConsumption from "@/components/charts/ChartsDashboard/Consumption.vue";
import Economy from "@/pages/Dashboard/Widgets/economy.vue";
import GeneralDetails from "@/pages/Dashboard/Widgets/generalDetails.vue";
import endpoint from "@/request/endpoint/dashboard.js";
import DashboardService from "@/services/server/DashboardService.js";
import ConsumptionService from "@/services/server/ConsumptionService.js";
import Utils from '@/scripts/Utils';
import DoughnutChart from "@/components/DoughnutChart.vue";
import WaterUsageChart from "@/components/charts/NewWaterUsageChart.vue";
import Carousel from './Widgets/carousel.vue';

// Import dashboard icons
import paidIcon from "@/assets/dashboard/paid.png";
import savingsIcon from "@/assets/dashboard/savings.png";
import lightbulbIcon from "@/assets/dashboard/lightbulb.png";
import targetIcon from "@/assets/dashboard/target.png";
import priorityHighIcon from "@/assets/dashboard/priority_high.png";

// import KpiCard from "@/components/KPI/KpiCard.vue";
import KpiCard from "@/pages/newDashboard/Widgets/KpiCard.vue";
import Alerts from "@/components/charts/ChartsDashboard/Alerts.vue";
import DoughnutAlertCard from "@/pages/newDashboard/Widgets/DoughnutAlertCard.vue";
import DoughnutGoalCard from "@/pages/newDashboard/Widgets/DoughnutGoalCard.vue";

import UnitsService from "@/services/server/UnitsService";
import AlertsNotificationsService from "@/services/server/AlertsNotificationService";
import { mapActions, mapGetters, mapMutations } from "vuex";



export default {
  name: "Dashboard",
  components: {
    KpiCard,
    DatePickerDialog,
    GeneralDetails,
    ChartAlert,
    ChartConsumption,
    ChartCall,
    SelectFranchisee,
    SelectClient,
    SelectUnit,
    Economy,
    Alerts,
    DoughnutChart,
    DoughnutGoalCard,
    DoughnutAlertCard,
    WaterUsageChart,
    Carousel,
  },

  data() {
    return {
      goalIcon: require('@/assets/menuIcons/goal.png'),
      // Dashboard icons
      paidIcon,
      savingsIcon,
      lightbulbIcon,
      targetIcon,
      priorityHighIcon,
      startDateDialog: false,
      startDatePicker: [Utils.formatDate(Utils.get_last_months()[0], '<YYYY>-<MM>'), Utils.formatDate(Utils.get_last_months()[5], '<YYYY>-<MM>')],
      franchisee_id: null,
      client_id: null,
      unit_id: null,
      openSelct: false,
      units: [],
      unit_ids: [],
      current_index_id: 0,
      is_executing: false,
      is_cycling: false,
      period: 6,
      progress_bar_fn: null,
      has_meta: false,
      parsed: null,
      selected: {
        franchisee_id: null,
        client_id: null,
        unit_id: null,
      },
      loading: {
        alerts: true,
        KPIData: true,
        consumption: true,
      },
      targetValue: 10000,
      waterUsageData: [
        { date: '01/ABR', value: 32 },
        { date: '04/ABR', value: 95 },
        { date: '07/ABR', value: 28 },
        { date: '10/ABR', value: 66 },
        { date: '13/ABR', value: 25 },
        { date: '16/ABR', value: 52 },
        { date: '19/ABR', value: 18 },
        { date: '22/ABR', value: 73 },
        { date: '25/ABR', value: 35 },
        { date: '28/ABR', value: 94 },
        { date: '30/ABR', value: 1 }
      ],
      waterUsageWeeklyData: [
        { date: 'Semana 1', value: 55 },
        { date: 'Semana 2', value: 48 },
        { date: 'Semana 3', value: 67 },
        { date: 'Semana 4', value: 44 }
      ],
      waterUsageMonthlyData: [
        { date: 'Jan', value: 42 },
        { date: 'Fev', value: 70 },
        { date: 'Mar', value: 46 },
        { date: 'Abr', value: 55 },
        { date: 'Mai', value: 62 },
        { date: 'Jun', value: 52 }
      ],
      consumptionChatData: {
        labels: [],
        dataset: []
      },
      continuousCycle: false,
      intervalId: null,
      isMounted: false,
      alertsData: [],
      KPIData: {
        alerts: '0',
        calleds: '0',
        totalFinancialEconomy: 'R$ 0',
        lastDateReading: "--/--/--",
        installationDate:"",
        goalEconomy:"0",
      },
      KPIDataColor: {
        alerts: 'primary',
        lastDateReading: 'primary',
      },
      econometerData: {
        avaregeFinancialEconomy: 0,
        avaregeWaterEconomy: 0,
        minFinancialEconomy: 0,
        minWaterEconomy: 0,
        totalFinancialEconomy: 0,
        totalWaterEconomy: 0,
      },
      display: {
        unit_name: "",
        percentage: 0,
        consumption: {
          title: "Consumo",
          percentage: 0,
          is_loading: false,
          data: {
            labels: [],
            datasets: [],
          }
        },
        economy: {
          title: "Economia",
          percentage: 0,
          is_loading: false,
          data: {
            consumption: {
              average: 0,
              min: 0,
              max: 0,
              total: 0,
              formatAverage: Utils.formatNumber(0),
              formatMin: Utils.formatNumber(0),
              formatMax: Utils.formatNumber(0),
              formatTotal: Utils.formatNumber(0),
            },
            valueCurrency: {
              average: 0,
              min: 0,
              max: 0,
              total: 0,
              formatAverage: Utils.formatCurrency(0),
              formatMin: Utils.formatCurrency(0),
              formatMax: Utils.formatCurrency(0),
              formatTotal: Utils.formatCurrency(0),
            },
            savingConsumption: {
              average: 0,
              min: 0,
              max: 0,
              total: 0,
              formatAverage: Utils.formatNumber(0),
              formatMin: Utils.formatNumber(0),
              formatMax: Utils.formatNumber(0),
              formatTotal: Utils.formatNumber(0),
            },
            savingCurrency: {
              average: 0,
              min: 0,
              max: 0,
              total: 0,
              formatAverage: Utils.formatCurrency(0),
              formatMin: Utils.formatCurrency(0),
              formatMax: Utils.formatCurrency(0),
              formatTotal: Utils.formatCurrency(0),
            }
          }
        },
        call: {
          title: "Chamados",
          percentage: 0,
          is_loading: false,
          data: {
            labels: [],
            datasets: [],
            total: 0,
          }
        },
        alert: {
          title: "Alerta",
          percentage: 0,
          is_loading: false,
          data: {
            data: [],
            labels: [],
            total: 0,
          }
        },
        goal: {
          title: "Meta",
          percentage: 0,
          is_loading: false,
          data: {
            last_reading_date: null,
            next_reading_date: null,
            end_reading_date: null,
            meta_estimate: 0,
            economy_estimate: 0,
            total_calls_finished: 0,
          }
        },
      },
      request: {
        consumption: null,
        call: null,
        alert: null,
        goal: null,
        reading: null,
        historic: null,
      },
      stack_execution: [],
      is_active_execution: false,
      is_process_execution: false,

      units_id_allowed_current_user: [],
      hasUnits: true,

      goalChartData: [
        { label: "Consumido", count: 5, color: '#63A9FF'},
        { label: "Limite", count: 5, color:'#D6EAF8' },
      ],
      totalAlertas: 11,
      totalMeta: 10,
      currentConsumption: {
        totalWaterMeasuredTotal: 0,
        totalWaterEstimatedTotal: 0,
        getGoalEconomyCubicMeters: 0,
        dailyGoalCubicMeters: 0,
      },
      dashboardGoalCalculation: null,
      dashboardBaselineConfig: null,
      dashboardHasBaselineConfig: false,
      nextReadingDates: {
        initialReadingDateEstimated: null,
        nextScheduledReadingDateEstimated: null
      },
      goalEconomyRaw: 0,
    };
  },
  computed: {
    ...mapGetters([
      "getUsers",
      "getCurrentUser",
      "getCurrentUserRank",
      "getCurrentUserID",
      "getSelectedUnit",
    ]),
    first_row_lg() {
      return this.has_meta ? 10 : 12
    },
    format_meta() {
      if (this.get_diff_meta == 0) return "--"
      return `${Utils.formatNumber(this.get_diff_meta)} M³`;
    },
    get_style_meta() {
      if (this.get_diff_meta == 0) return "padding: 15px;background-color: grey;color: white;font-weight: bold;font-size: 2vh;border-radius: 30px;";
      else if (this.get_diff_meta > 0) return "padding: 15px;background-color: rgb(34, 140, 34);color: white;font-weight: bold;font-size: 2vh;border-radius: 30px;";
      else return "padding: 15px;background-color: red;color: white;font-weight: bold;font-size: 2vh;border-radius: 30px;";
    },
    get_text_meta() {
      if (this.get_diff_meta == 0) return "--"
      else if (this.get_diff_meta > 0) return "Economia"
      else return "Ultrapassou"
    },
    get_text_style_meta() {
      if (this.get_diff_meta == 0) return "padding: 15px;color: grey;font-weight: bold;font-size: 2.2vh;"
      else if (this.get_diff_meta > 0) return "padding: 15px;color: rgb(34, 140, 34);font-weight: bold;font-size: 2.2vh;"
      else return "padding: 15px;color: red;font-weight: bold;font-size: 2.2vh;"
    },
    get_last_reading_date() {
      if (!this.display.goal.data.last_reading_date) return "--/--/--";
      return Utils.formatDate(this.display.goal.data.last_reading_date, "<DD>/<MM>/<YYYY>")
    },
    get_next_reading_date() {
      if (!this.display.goal.data.next_reading_date) return "--/--/--";
      return Utils.formatDate(this.display.goal.data.next_reading_date, "<DD>/<MM>/<YYYY>")
    },
    get_meta_estimate() {
      return Utils.formatNumber(this.display.goal.data.meta_estimate);
    },
    get_economy_estimate() {
      return Utils.formatNumber(this.display.goal.data.economy_estimate)
    },
    get_total_alerts() {
      return this.display.alert.data.total
    },
    get_end_reading_date() {
      if (!this.display.goal.data.end_reading_date) return "--/--/--";
      return Utils.formatDate(this.display.goal.data.end_reading_date, "<DD>/<MM>/<YYYY>")
    },
    get_total_calls_finished() {
      return this.display.goal.data.total_calls_finished
    },
    dashboardGoalReference() {
      return this.dashboardGoalCalculation?.referencia || null;
    },
    dashboardGoalModeLabel() {
      const mode = this.dashboardGoalReference?.mode;
      if (mode === "monthlyBaseline") return "Baseline mensal";
      if (mode === "fixedBaseline") return "Baseline fixa";
      if (mode === "driverAdjusted") return "Baseline ajustada por driver";
      if (this.dashboardHasBaselineConfig) return "Baseline configurada";
      return "";
    },
    dashboardGoalModeTooltip() {
      const mode = this.dashboardGoalReference?.mode;
      if (mode === "monthlyBaseline") {
        return "Baseline mensal: a meta usa os valores cadastrados para o mês vigente da baseline atual.";
      }
      if (mode === "fixedBaseline") {
        return "Baseline fixa: a meta parte de uma referência mensal fixa e é distribuída no período de leitura atual.";
      }
      if (this.dashboardHasBaselineConfig) {
        return "Meta calculada a partir da baseline atual configurada para esta unidade.";
      }
      return "";
    },
    dashboardGoalBreakdown() {
      const goal = this.dashboardGoalCalculation || {};
      return {
        water: Number(goal.metaAgua || 0),
        sewer: Number(goal.metaEsgoto || 0),
        total: Number(goal.metaTotal || this.currentConsumption.getGoalEconomyCubicMeters || 0),
        percent: Number(goal.metaEconomiaPercentual || 0),
      };
    },
    dashboardGoalDailyTooltip() {
      const total = this.formatVolume(this.dashboardGoalBreakdown.total);
      const daily = this.formatVolume(this.currentConsumption.dailyGoalCubicMeters || this.goalEconomyRaw);
      return `${this.dashboardGoalModeLabel}. Meta mensal total: ${total}. Valor diario exibido: ${daily}, proporcional ao periodo estimado de leitura.`;
    },
    /**
     * Calculates impact data based on total water economy
     */
    impactData() {
      // Convert string to number and ensure it's valid
      const totalWaterEconomy = parseFloat(this.econometerData.totalWaterEconomy) || 0;
      
      // Constants for calculations (average consumption values)
      const LITERS_PER_CUBIC_METER = 1000;
      const DAILY_WATER_NEEDS_PER_FAMILY = 300; // liters per day for a family
      const SHOWER_WATER_USAGE = 45; // liters for a 3-minute shower
      const CHILD_DAILY_WATER_NEEDS = 4; // liters per day for a child
      
      // Calculate impact values based on total water economy in cubic meters
      const totalWaterEconomyLiters = totalWaterEconomy * LITERS_PER_CUBIC_METER;
      
      // Calculate how many families' daily needs can be supplied
      const familiesSupplied = Math.max(1, Math.round(totalWaterEconomyLiters / DAILY_WATER_NEEDS_PER_FAMILY));
      const daysForFamilies = Math.max(1, Math.round(totalWaterEconomyLiters / (DAILY_WATER_NEEDS_PER_FAMILY * familiesSupplied)));
      
      // Calculate how many showers can be taken
      const showersProvided = Math.max(1, Math.round(totalWaterEconomyLiters / SHOWER_WATER_USAGE));
      
      // Calculate how many children's thirst can be quenched
      const childrenHydrated = Math.max(1, Math.round(totalWaterEconomyLiters / (CHILD_DAILY_WATER_NEEDS * 2)));
      const daysForChildren = Math.max(1, 2); // Fixed at 2 days as requested in original template
      
      return {
        familiesSupplied,
        daysForFamilies,
        showersProvided,
        childrenHydrated,
        daysForChildren
      };
    },
    impactCarouselSlides() {
      if (parseFloat(this.econometerData.totalWaterEconomy) <= 0) {
        return [
          {
            text: 'Não há dados de economia',
            image: require('@/../public/img/carousel/crazy.png'),
            bgColor: 'linear-gradient(135deg, #4e9af1 0%, #6fd6ff 100%)'
          }
        ];
      }
      return [
        {
          text: `${this.impactData.familiesSupplied} famílias por ${this.impactData.daysForFamilies} dia${this.impactData.daysForFamilies > 1 ? 's' : ''}.`,
          image: require('@/../public/img/carousel/crazy.png'),
        },
        {
          text: `${this.impactData.showersProvided} banhos de 3 minutos.`,
          image: require('@/../public/img/carousel/shower.png'),
        },
        {
          text: `${this.impactData.childrenHydrated} crianças por ${this.impactData.daysForChildren} dias.`,        
          image: require('@/../public/img/carousel/kids.png'),
        }
      ];
    },
  },
  watch: {
    getSelectedUnit: {
      handler(newUnit) {
        //conditional to clear states when dont have any unit selected
        if (newUnit === null) {
          this.waterUsageData = [];
          this.econometerData = {
            avaregeFinancialEconomy: 0,
            avaregeWaterEconomy: 0,
            minFinancialEconomy: 0,
            minWaterEconomy: 0,
            totalFinancialEconomy: 0,
            totalWaterEconomy: 0,
          };
          this.KPIData = {
            alerts: '0',
            calleds: '0',
            totalFinancialEconomy: 'R$ 0',
            lastDateReading: "--/--/--",
            installationDate: "",
            goalEconomy: "0",
          };
          this.currentConsumption = {
            totalWaterMeasuredTotal: 0,
            totalWaterEstimatedTotal: 0,
            getGoalEconomyCubicMeters: 0,
            dailyGoalCubicMeters: 0,
          };
          this.dashboardGoalCalculation = null;
          this.dashboardBaselineConfig = null;
          this.dashboardHasBaselineConfig = false;
          this.nextReadingDates = {
            initialReadingDateEstimated: '',
            nextScheduledReadingDateEstimated: '',
          };
          this.loading.KPIData = false;
          this.loading.alerts = false;
          this.loading.consumption = false;
          this.alertsData = [];
          this.display.unit_name = '';
          return;
        }
        if (Array.isArray(this.units) && this.units.length > 0 && newUnit && newUnit.id) {
          this.unit_id = newUnit.id;
          this.display.unit_name = newUnit.title || this.get_unit_name(newUnit.id);
          this.searchUnit();
        }
      },
      immediate: true
    },
    '$store.getters.unitMeasure': {
      handler(newVal) {
        this.updateAdjustedGoalEconomy();
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      "getUnitsBy",
      "initUsersAndUnits",
      "getUsersBy",
    ]),
    ...mapMutations(["SET_SELECTED_UNIT"]),
    async clearDateCalendar() {
      this.startDatePicker = [Utils.formatDate(Utils.get_last_months()[0], '<YYYY>-<MM>'), Utils.formatDate(Utils.get_last_months()[5], '<YYYY>-<MM>')]
    },
    async selectDateCalendar(date) {
      if (this.startDatePicker[0] > this.startDatePicker[1]) {
        let date_1 = this.startDatePicker[1]
        let date_2 = this.startDatePicker[0]
        this.startDatePicker[0] = date_1
        this.startDatePicker[1] = date_2
      }
      this.startDateDialog = false

    },
    add_execution(fn_promise) {
      this.stack_execution.push(fn_promise)
    },
    catch_franchisee_id(franchisee_id) {
      this.franchisee_id = franchisee_id;
    },
    catch_client_id(client_id) {
      this.client_id = client_id;
    },
    async catch_unit_id(unit_id) {
      this.unit_id = unit_id;
      if (this.units.length <= 0) return;
    },
    async searchUnit() {

      this.continuousCycle = false
      this.display.unit_name = this.get_unit_name(this.unit_id);
      this.openSelct = !this.openSelct


      await Promise.all([this.getKPIsData(this.unit_id)])
    },

    set_selected(franchisee_id, client_id, unit_id) {
      this.selected = {
        franchisee_id,
        client_id,
        unit_id,
      }
    },

    clear_selected() {
      this.set_selected(null, null, null)
    },

    get_next_unit() {
      let parsed = {
        "type": null,
        "id": null,
        "unit_id": null,
        "start_date": this.startDatePicker[0],
        "end_date": this.startDatePicker[1],
      }
      if (this.selected.unit_id !== null) {
        if (this.selected.unit_id !== 'selecionar_todos') {
          parsed = {
            type: "unit",
            id: this.selected.unit_id,
            unit_id: this.selected.unit_id,
            "start_date": this.startDatePicker[0],
            "end_date": this.startDatePicker[1],
          }
        } else if (this.selected.client_id) {
          parsed = {
            type: "client",
            id: this.selected.client_id,
            unit_id: this.selected.unit_id,
            "start_date": this.startDatePicker[0],
            "end_date": this.startDatePicker[1],
          }
        } else if (this.selected.franchisee_id) {
          parsed = {
            type: "franchisee",
            id: this.selected.franchisee_id,
            unit_id: this.selected.unit_id,
            "start_date": this.startDatePicker[0],
            "end_date": this.startDatePicker[1],
          }
        }
      } else {
        let max_length = this.unit_ids.length
        if (this.current_index_id >= max_length) this.current_index_id = 0;
        parsed.type = "unit"
        parsed.id = this.unit_ids[this.current_index_id]
        parsed.unit_id = this.unit_ids[this.current_index_id]
        this.current_index_id++;
      }
      return parsed;
    },
    set_loading_display(type, status) {
      this.display[type].is_loading = status
    },

    get_loading_display(type) {
      return this.display[type].is_loading
    },

    set_display_data(type, data) {
      this.display[type].data = {
        ...this.display[type].data,
        ...data
      }
    },

    get_user_name(id) {
      let user = this.getUsers.find(
        (u) => {
          return u.id == id
        }
      )
      return user.hasOwnProperty('data') ? user.data.name : user.name;
    },

    get_unit_name(unit_id) {
      if (!Array.isArray(this.units)) return '';
      const unit = this.units.find((u) => u && u.id == unit_id);
      return unit && unit.name ? unit.name : '';
    },

    get_unit_start(unit_id) {
      let unit = this.units.find(
        (u) => {
          return u.id == unit_id;
        }
      )
      if(unit.dataMediaHistorico == null) return ""
      const date = new Date(unit.dataMediaHistorico);
      return `Desde ${date.getMonth() + 1}/${date.getFullYear()}`;
    },

    set_unit_name(parsed) {
      if (parsed.unit_id != 'selecionar_todos') {
        this.display.unit_name = this.get_unit_name(parsed.unit_id);
      } else if (parsed.type !== null) {
        this.display.unit_name = this.get_user_name(parsed.id);
      } else {
        this.display.unit_name = ''
      }
      this.SET_SELECTED_UNIT({ id: parsed.unit_id, title: this.display.unit_name,
        estimateStartDate: this.nextReadingDates.initialReadingDateEstimated ,estimateEndDate:this.nextReadingDates.nextScheduledReadingDateEstimated});
    },
    async getAlertsData(unit_id) {
      this.loading.alerts = true
      const teste = await AlertsNotificationsService.findByUnit(unit_id)
      this.alertsData = teste.data
      this.loading.alerts = false
    },
    async getKPIsData(unit_id) {
      this.loading.KPIData = true;
      this.KPIDataColor.lastDateReading = "primary"
      this.KPIDataColor.alerts = "primary"

      this.econometerData = {
        avaregeFinancialEconomy: 0,
        avaregeWaterEconomy: 0,
        minFinancialEconomy: 0,
        minWaterEconomy: 0,
        totalFinancialEconomy: 0,
        totalWaterEconomy: 0,
        maxWaterEconomy: 0,
        maxFinancialEconomy: 0,
      }

      await DashboardService.findKPIbyUnit(unit_id)
        .then((res) => {
          const dataKPI = res.data.data
          this.waterUsageData = dataKPI.waterUsageData || []
          this.targetValue = dataKPI.targetValue
          this.nextReadingDates = dataKPI.nextReadingDates || {
            initialReadingDateEstimated: null,
            nextScheduledReadingDateEstimated: null
          }
          const [, month, year] = this.nextReadingDates.initialReadingDateEstimated.split('/');
          const formatted = `${month.padStart(2, '0')}/${year}`;
          this.nextReadingDates.monthYear = formatted
          this.currentConsumption = dataKPI.goal
          this.dashboardGoalCalculation = dataKPI.goalCalculation || null
          this.dashboardBaselineConfig = dataKPI.baselineConfig || null
          this.dashboardHasBaselineConfig = Boolean(dataKPI.hasBaselineConfig)
          this.alertsData = dataKPI.alerts

          const formatCurrencyValue = (value) => {
            return new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(value);
          }

          let goalEconomy = dataKPI.goal.dailyGoalCubicMeters
            ?? dataKPI.dailyGoalCubicMeters
            ?? ((dataKPI.goal.getGoalEconomyCubicMeters) / 30);
          this.goalEconomyRaw = goalEconomy;
          this.updateAdjustedGoalEconomy();
          this.KPIData.installationDate= this.get_unit_start(this.unit_id)
          this.econometerData.avaregeFinancialEconomy = formatCurrencyValue(dataKPI.econometer.avaregeFinancialEconomy)
          this.econometerData.minFinancialEconomy = formatCurrencyValue(dataKPI.econometer.minFinancialEconomy)
          this.econometerData.totalFinancialEconomy = formatCurrencyValue(dataKPI.econometer.totalFinancialEconomy)
          this.econometerData.maxFinancialEconomy = formatCurrencyValue(dataKPI.econometer.maxFinancialEconomy)

          this.econometerData.minWaterEconomy = (dataKPI.econometer.minWaterEconomy).toFixed(2)
          this.econometerData.avaregeWaterEconomy = (dataKPI.econometer.avaregeWaterEconomy).toFixed(2)
          this.econometerData.totalWaterEconomy = (dataKPI.econometer.totalWaterEconomy).toFixed(2)
          this.econometerData.maxWaterEconomy = (dataKPI.econometer.maxWaterEconomy).toFixed(2)

        }).finally(() => this.loading.KPIData = false)
    },
    async execute() {
      const execute = async () => {
        try {
          if (!this.isMounted || !this.continuousCycle) {
            clearTimeout(this.intervalId);
            return;
          }
          
          // Limpar o timeout anterior para evitar múltiplas instâncias
          if (this.intervalId) {
            clearTimeout(this.intervalId);
            this.intervalId = null;
          }
          
          this.parsed = this.get_next_unit();
          this.set_unit_name(this.parsed);
          this.loading.consumption = true;

          await Promise.all([this.getKPIsData(this.parsed.unit_id)])

        } catch (error) {
          // Erro durante a execução silenciado
        } finally {
          // Definir um tempo limite máximo de execução para evitar sobrecarga
          if (this.continuousCycle && this.isMounted) {
            this.intervalId = setTimeout(execute, 10000);
          }
        }
      };
      
      // Iniciar apenas se não estiver já em execução
      if (!this.intervalId) {
        execute();
      }
    },
    checkContinuousCycle() {
      this.continuousCycle = !this.continuousCycle
      if (this.continuousCycle) this.execute()
    },
    updateAdjustedGoalEconomy() {
      const unitMeasure = this.$store.getters.unitMeasure;
      let adjustedGoalEconomy = this.goalEconomyRaw;
      let unitSuffix = 'M³';
      if (unitMeasure === 'liters') {
        adjustedGoalEconomy = this.goalEconomyRaw * 1000;
        unitSuffix = 'L';
      }
      this.KPIData.goalEconomy = adjustedGoalEconomy.toFixed(2).replace('.', ',') + ' ' + unitSuffix;
    },
    formatVolume(value) {
      const numeric = Number(value || 0);
      const unitMeasure = this.$store.getters.unitMeasure;
      const scaledValue = unitMeasure === 'liters' ? numeric * 1000 : numeric;
      const unitSuffix = unitMeasure === 'liters' ? 'L' : 'M³';
      return `${scaledValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${unitSuffix}`;
    },
  },
  async mounted() {
    this.isMounted = true;
    UnitsService.findAll()
      .then((res) => {
        this.units = res.data.data;
        this.unit_ids = this.units.map(unit => unit.id);
        this.current_index_id = 0;
        if (this.units.length <= 0) {
          this.hasUnits = false;
        }
        if (this.units.length > 0) this.execute();

        const selectedUnit = this.$store.getters.getSelectedUnit;
        if (selectedUnit && selectedUnit.id) {
          this.unit_id = selectedUnit.id;
          this.display.unit_name = selectedUnit.title || this.get_unit_name(selectedUnit.id);
          this.searchUnit();
        }
      })
      .catch();
  },
  beforeDestroy() {
    this.isMounted = false;
    
    // Garantir que o ciclo contínuo seja interrompido
    this.continuousCycle = false;
    
    // Limpar todos os temporizadores
    if (this.intervalId) {
      clearTimeout(this.intervalId);
      this.intervalId = null;
    }
    
    // Limpar dados que podem estar ocupando memória
    this.alertsData = [];
    this.waterUsageData = [];
    this.waterUsageWeeklyData = [];
    this.waterUsageMonthlyData = [];
  },
};
